import { render, staticRenderFns } from "./BeGoogleAuthButton.vue?vue&type=template&id=6e826c78&scoped=true"
import script from "./BeGoogleAuthButton.vue?vue&type=script&lang=js"
export * from "./BeGoogleAuthButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e826c78",
  null
  
)

export default component.exports